export const basePallet = {
  primary: {
    main: "#762C85",
  },
  secondary: {
    main: "#0CF1A7",
  },
};
